export interface AddToCartRequest {
  addToCartButton?: HTMLElement;
  originalAddToCartButton?: HTMLElement;
  cartAction?: CartAction;
  membership?: boolean;
  sellingPlanId?: string;
  livestreamId?: string;
  postId?: string;
  productVariantId: string | number;
  referralLinkId?: string;
  optInToMarketingEmails?: boolean;
  product?: any;
  quantity?: number;
}

export interface BuyItNowRequest {
  accessToken: string;
  membership?: boolean;
  sellingPlanId?: string;
  livestreamId?: string;
  postId?: string;
  productVariantId: string;
  referralLinkId?: string;
  optInToMarketingEmails?: boolean;
  product?: any;
}

export enum CartAction {
  OPEN_CART_IN_NEW_TAB = 'OPEN_CART_IN_NEW_TAB',
  OPEN_CART_IN_CURRENT_TAB = 'OPEN_CART_IN_CURRENT_TAB',
  NONE = 'NONE',
}

export class SoldOutItemError extends Error {
  variantId: string;

  constructor(variantId: string) {
    super();
    this.variantId = variantId;
  }
}
